import englishMessages from 'ra-language-english';

export default {
    ...englishMessages,
    pos: {
        search: 'Search',
        configuration: 'Configuration',
        language: 'Language',
        theme: {
            name: 'Theme',
            light: 'Light',
            dark: 'Dark',
        },
        dashboard: {
            welcome: {
                title: 'Welcome to WellBeyond Administration Beta',
                subtitle:
                    "This is the administration interface for the Well Beyond application beta.",
                aor_button: 'well beyond site',
                demo_button: 'Source for this app',
            },
        },
        menu: {
            users: 'Users',
            organizations: 'Organizations',
            systems: 'Water Systems',
            rules: 'Diagnostic Rules',
            maintenance: 'Maintenance Checklists',
            training: 'Training Classes',
            forms: 'Forms',
            assets: 'Photos and Videos',
            systemOverview: 'System Overview',
        },
    },
    resources: {
        systemTypes: {
            name: 'System Type |||| System Types',
            amount: '1 system type |||| %{smart_count} system types',
            title: 'System Type %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        systems: {
            name: 'System |||| Systems',
            amount: '1 system |||| %{smart_count} systems',
            title: 'System %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        symptoms: {
            name: 'Problem |||| Problems',
            amount: '1 problem |||| %{smart_count} problems',
            title: 'Problem %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        solutions: {
            name: 'Solution |||| Solutions',
            amount: '1 solution |||| %{smart_count} solutions',
            title: 'Solution %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        facts: {
            name: 'Fact |||| Facts',
            amount: '1 fact |||| %{smart_count} facts',
            title: 'Fact %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        diagnostics: {
            name: 'Question |||| Questions',
            amount: '1 fact |||| %{smart_count} question',
            title: 'Question %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        diagnosticLogs: {
            name: 'Diagnostic Log |||| Diagnostic Logs',
            amount: '1 diagnostic Log |||| %{smart_count} diagnostic Logs',
            title: 'Diagnostic Log %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        checklists: {
            name: 'Checklist |||| Checklists',
            amount: '1 checklist |||| %{smart_count} checklists',
            title: 'Checklist %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        maintenanceLogs: {
            name: 'Maintenance Log |||| Maintenance Logs',
            amount: '1 maintenance Log |||| %{smart_count} maintenance Logs',
            title: 'Maintenance Log %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        topics: {
            name: 'Topic |||| Topics',
            amount: '1 topic |||| %{smart_count} topics',
            title: 'Topic %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        subjects: {
            name: 'Subject |||| Subjects',
            amount: '1 subject |||| %{smart_count} subjects',
            title: 'Subject %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        lessons: {
            name: 'Lesson |||| Lessons',
            amount: '1 lesson |||| %{smart_count} lessons',
            title: 'Lesson %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        sessions: {
            name: 'Training Session |||| Training Sessions',
            amount: '1 session |||| %{smart_count} sessions',
            title: 'Training Session %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        photos: {
            name: 'Photo |||| Photos',
            amount: '1 photo |||| %{smart_count} photos',
            title: 'Photo %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        videos: {
            name: 'Video |||| Videos',
            amount: '1 video |||| %{smart_count} videos',
            title: 'Video %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        users: {
            name: 'User |||| Users',
            amount: '1 user |||| %{smart_count} users',
            title: 'User %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        forms: {
            name: 'Form |||| Forms',
            amount: '1 form |||| %{smart_count} forms',
            title: 'Form %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        formTypes: {
            name: 'Form Type |||| Form Types',
            amount: '1 form type |||| %{smart_count} form types',
            title: 'Form Type %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        formSessions: {
            name: 'Form Submission |||| Form Submissions',
            amount: '1 form submission |||| %{smart_count} form submissions',
            title: 'Form Submission %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        admins: {
            name: 'Administrator |||| Administrators',
            amount: '1 administrator |||| %{smart_count} administrators',
            title: 'Administrator %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
        organizations: {
            name: 'Organization |||| Organizations',
            amount: '1 organization |||| %{smart_count} organizations',
            title: 'Organization %{reference}',
            fields: {
            },
            tabs: {
            },
            action: {
            },
            notification: {
            }
        },
    },
};